/* ============================================================
   VALORA BEANS AND BARS — THEME JS  (Mobile-First)
   ============================================================ */
document.addEventListener('DOMContentLoaded', () => {

  /* ── CART STATE ───────────────────────────────────────── */
  let cart = [];
  try { cart = JSON.parse(localStorage.getItem('valora_cart') || '[]'); } catch(e) { cart = []; }
  window._cartRef = cart; // expose for product page buyNowMagic

  function saveCart(){ try{ localStorage.setItem('valora_cart', JSON.stringify(cart)); }catch(e){} }
  function getCartCount(){ return cart.reduce((s,i)=>s+i.qty,0); }
  function getCartTotal(){ return cart.reduce((s,i)=>s+(i.price*i.qty),0); }

  /* ── CART UI ──────────────────────────────────────────── */
  function updateCartUI(){
    const count = getCartCount();
    document.querySelectorAll('.cart-count').forEach(el=>{
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
    renderCartItems();
    renderCartPage();
  }

  /* ── CART DRAWER ──────────────────────────────────────── */
  const overlay = document.querySelector('.cart-overlay');
  const drawer  = document.querySelector('.cart-drawer');

  function openCart(){
    overlay?.classList.add('open');
    drawer?.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart(){
    overlay?.classList.remove('open');
    drawer?.classList.remove('open');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('.cart-trigger').forEach(el=>el.addEventListener('click', openCart));
  overlay?.addEventListener('click', closeCart);
  document.querySelector('.cart-close')?.addEventListener('click', closeCart);

  document.getElementById('cart-clear-btn')?.addEventListener('click', () => {
    if(cart.length === 0) return;
    cart.splice(0, cart.length);
    saveCart(); updateCartUI();
    showToast('Cart cleared');
  });

  /* Swipe-to-close on mobile */
  let touchStartX = 0;
  drawer?.addEventListener('touchstart', e=>{ touchStartX = e.touches[0].clientX; }, {passive:true});
  drawer?.addEventListener('touchend', e=>{
    if(e.changedTouches[0].clientX - touchStartX > 80) closeCart();
  }, {passive:true});

  /* ── RENDER CART DRAWER ───────────────────────────────── */
  function renderCartItems(){
    const container = document.getElementById('cart-items-list');
    if(!container) return;

    if(cart.length === 0){
      container.innerHTML = `
        <div class="cart-empty">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
            <line x1="3" y1="6" x2="21" y2="6"/>
            <path d="M16 10a4 4 0 01-8 0"/>
          </svg>
          <p>Your cart is empty</p>
          <a href="/collections/all" style="color:var(--gold);font-size:13px;text-decoration:underline;margin-top:8px;display:block;" onclick="closeCart()">Browse Chocolates →</a>
        </div>`;
      document.getElementById('cart-total-price').textContent = '₹0';
      return;
    }

    container.innerHTML = cart.map((item,idx)=>`
      <div class="cart-item">
        <div class="cart-item-img">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="rgba(201,148,58,0.55)" stroke-width="1.2">
            <rect x="2" y="4" width="20" height="16" rx="3"/>
            <line x1="7" y1="4" x2="7" y2="20"/>
            <line x1="12" y1="4" x2="12" y2="20"/>
          </svg>
        </div>
        <div class="cart-item-info">
          <div class="cart-item-name">${item.name}</div>
          <div class="cart-item-variant">${item.variant}</div>
          <div class="cart-item-qty">
            <button class="qty-btn" onclick="window.updateQty(${idx},-1)" aria-label="Decrease">−</button>
            <span class="qty-num">${item.qty}</span>
            <button class="qty-btn" onclick="window.updateQty(${idx},1)" aria-label="Increase">+</button>
          </div>
        </div>
        <div style="display:flex;flex-direction:column;align-items:flex-end;gap:8px;">
          <div class="cart-item-price">₹${(item.price*item.qty).toLocaleString('en-IN')}</div>
          <button onclick="window.updateQty(${idx},-99)" aria-label="Remove item"
            style="font-size:18px;color:var(--text-light);padding:2px 6px;background:none;border:none;cursor:pointer;line-height:1;">×</button>
        </div>
      </div>`).join('');

    document.getElementById('cart-total-price').textContent =
      '₹' + getCartTotal().toLocaleString('en-IN');
  }

  window.updateQty = function(idx, delta){
    if(!cart[idx]) return;
    cart[idx].qty += delta;
    if(cart[idx].qty <= 0) cart.splice(idx,1);
    saveCart(); updateCartUI();
  };

  /* ── ADD TO CART (global) ─────────────────────────────── */
  window.addToCart = function(name, price, variant, variantId, silent){
    const existing = cart.find(i=>i.name===name && i.variant===variant);
    if(existing){ existing.qty++; }
    else { cart.push({name, price, variant, qty:1, variantId: variantId||null}); }
    saveCart(); updateCartUI();
    if(!silent) openCart();
    showToast(`${name} (${variant}) added! 🍫`);
  };

  /* ── AJAX ADD-TO-CART (intercept product-card forms) ──── */
  /*
   * The home-page product cards use <form action="/cart/add">.
   * Without interception the browser does a full-page POST to
   * Shopify's native cart — which never updates localStorage —
   * so the drawer always looks empty.
   *
   * We intercept every such form, POST it via fetch() so Shopify
   * records the line item in its own session cart, then also push
   * the item into localStorage so the drawer / cart page reflect it.
   */
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();

      const variantInput = form.querySelector('[name="id"]');
      const variantId    = variantInput ? variantInput.value : null;
      if (!variantId) { showToast('Please select a variant', 'error'); return; }

      /* Read displayed product name & price from the card */
      const card        = form.closest('.product-card');
      const productName = card ? (card.querySelector('h3')?.textContent?.trim() || 'Product') : 'Product';
      const activeBtn   = card ? card.querySelector('.weight-btn.active') : null;
      const variantName = activeBtn ? activeBtn.textContent.trim() : 'Default';

      /* Price: use data-price-cents (raw Shopify integer in paisa e.g. 24900)
         and divide by 100 to get ₹249. This avoids any locale/format issues
         with the money-filtered string (₹249.00, Rs. 249,00, etc.) */
      let priceCents = activeBtn ? parseInt(activeBtn.getAttribute('data-price-cents') || '0', 10) : 0;
      if (!priceCents && card) {
        /* fallback: read price-value text, strip non-numeric, treat as rupees */
        const txt = card.querySelector('.price-value')?.textContent || '0';
        priceCents = parseFloat(txt.replace(/[^0-9.]/g, '')) * 100 || 0;
      }
      const price = priceCents / 100;

      /* Disable button while posting */
      const btn = form.querySelector('.add-to-cart-btn');
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      try {
        /* Tell Shopify's own cart about this item (keeps checkout in sync) */
        const resp = await fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ id: variantId, quantity: 1 })
        });

        if (!resp.ok) {
          const err = await resp.json().catch(() => ({}));
          showToast(err.description || 'Could not add to cart', 'error');
          return;
        }

        /* Also update localStorage so the drawer reflects the item */
        const existing = cart.find(i => i.name === productName && i.variant === variantName);
        if (existing) { existing.qty++; }
        else { cart.push({ name: productName, price, variant: variantName, qty: 1, variantId }); }
        saveCart(); updateCartUI(); openCart();
        showToast(`${productName} (${variantName}) added! 🍫`);

      } catch(err) {
        showToast('Network error – please try again', 'error');
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; }
      }
    });
  });

  /* ── CHECKOUT HANDLER ─────────────────────────────────────
   *
   * TWO problems solved here:
   *
   * 1. OLD PRODUCTS IN CHECKOUT — Shopify's server-side cart
   *    accumulates every /cart/add.js call across sessions.
   *    We must call /cart/clear.js + re-add ONLY the current
   *    items BEFORE navigating, so checkout sees exactly what
   *    the customer wants right now.
   *
   * 2. REDIRECT BACK TO HOME — happens when checkout opens an
   *    empty Shopify cart. The old code matched only href="/checkout"
   *    but the cart page uses href="/checkout?discount=..." which
   *    never matched. Fixed by matching any href starting with /checkout.
   *
   * ─────────────────────────────────────────────────────── */
  /* Checkout links → Magic Checkout (handled by the engine in theme.liquid)
     This is a safety net — the engine already binds these on DOMContentLoaded */
  document.querySelectorAll('a[href^="/checkout"]').forEach(link => {
    if(link.dataset.rzpBound) return;
    link.dataset.rzpBound = '1';
    link.addEventListener('click', function(e) {
      e.preventDefault();
      if(window.valoraOpenMagicCheckout) valoraOpenMagicCheckout();
    });
  });

  /* ── TOAST ────────────────────────────────────────────── */
  window.showToast = function(msg, type='success'){
    document.querySelectorAll('.valora-toast').forEach(t=>t.remove());
    const toast = document.createElement('div');
    toast.className = 'valora-toast';
    toast.style.cssText = `
      position:fixed; bottom:24px; left:50%; transform:translateX(-50%) translateY(20px);
      background:${type==='error'?'#8B1A1A':'#C9943A'}; color:#1E0A02;
      padding:13px 24px; border-radius:100px;
      font-family:'Jost',sans-serif; font-size:13px; font-weight:600;
      z-index:9999; box-shadow:0 8px 32px rgba(0,0,0,0.35);
      opacity:0; transition:all 0.3s ease; white-space:nowrap;
      max-width:calc(100vw - 40px); text-align:center;
    `;
    toast.textContent = msg;
    document.body.appendChild(toast);
    requestAnimationFrame(()=>{
      toast.style.opacity='1'; toast.style.transform='translateX(-50%) translateY(0)';
    });
    setTimeout(()=>{
      toast.style.opacity='0'; toast.style.transform='translateX(-50%) translateY(10px)';
      setTimeout(()=>toast.remove(), 300);
    }, 3000);
  };

  /* ── MOBILE NAV ───────────────────────────────────────── */
  const mobileNav = document.getElementById('mobile-nav');
  document.querySelector('.mobile-menu-btn')?.addEventListener('click', ()=>{
    mobileNav?.classList.add('open');
    document.body.style.overflow = 'hidden';
  });
  document.querySelector('.mobile-nav-close')?.addEventListener('click', ()=>{
    mobileNav?.classList.remove('open');
    document.body.style.overflow = '';
  });
  mobileNav?.addEventListener('click', e=>{
    if(e.target === mobileNav){
      mobileNav.classList.remove('open');
      document.body.style.overflow='';
    }
  });
  /* Close mobile nav links on tap */
  mobileNav?.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{
    mobileNav.classList.remove('open');
    document.body.style.overflow='';
  }));

  /* ── WEIGHT / VARIANT BUTTONS ─────────────────────────── */
  document.querySelectorAll('.weight-btn').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const group = btn.closest('.product-weight-options');
      group?.querySelectorAll('.weight-btn').forEach(b=>b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  /* ── FILTER BUTTONS ───────────────────────────────────── */
  document.querySelectorAll('.filter-btn').forEach(btn=>{
    btn.addEventListener('click',()=>{
      document.querySelectorAll('.filter-btn').forEach(b=>b.classList.remove('active'));
      btn.classList.add('active');
      const filter = btn.dataset.filter;
      document.querySelectorAll('.product-card').forEach(card=>{
        card.style.display = (filter==='all'||card.dataset.category===filter) ? '' : 'none';
      });
    });
  });

  /* ── CART PAGE TABLE ──────────────────────────────────── */
  function renderCartPage(){
    const table = document.getElementById('cart-page-items');
    if(!table) return;

    if(cart.length === 0){
      table.innerHTML = `<tr><td colspan="5" style="text-align:center;padding:52px;font-family:'Cormorant Garamond',serif;font-size:17px;color:#A07855;">
        Your cart is empty.
        <a href="/collections/all" style="color:#C9943A;text-decoration:underline;display:block;margin-top:10px;">Continue Shopping →</a>
      </td></tr>`;
    } else {
      table.innerHTML = cart.map((item,idx)=>`
        <tr>
          <td>
            <div class="cart-product-cell">
              <div style="width:72px;height:72px;background:linear-gradient(135deg,#4A1C08,#6B2C10);border-radius:6px;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="rgba(201,148,58,0.55)" stroke-width="1.2"><rect x="2" y="4" width="20" height="16" rx="3"/></svg>
              </div>
              <div>
                <div style="font-weight:500;color:#1A0800;margin-bottom:3px;">${item.name}</div>
                <div style="font-size:11px;color:#C9943A;">${item.variant}</div>
              </div>
            </div>
          </td>
          <td style="color:#5C3D2A;font-size:14px;">₹${item.price.toLocaleString('en-IN')}</td>
          <td>
            <div style="display:flex;align-items:center;gap:6px;border:1.5px solid rgba(74,28,8,0.14);border-radius:4px;overflow:hidden;width:fit-content;">
              <button onclick="window.updateQtyPage(${idx},-1)" style="width:34px;height:36px;background:#F5EAD8;border:none;cursor:pointer;font-size:17px;color:#1A0800;display:flex;align-items:center;justify-content:center;">−</button>
              <span style="padding:0 8px;font-size:14px;color:#1A0800;min-width:24px;text-align:center;">${item.qty}</span>
              <button onclick="window.updateQtyPage(${idx},1)" style="width:34px;height:36px;background:#F5EAD8;border:none;cursor:pointer;font-size:17px;color:#1A0800;display:flex;align-items:center;justify-content:center;">+</button>
            </div>
          </td>
          <td style="font-family:'Playfair Display',serif;font-size:17px;font-weight:700;color:#1A0800;">₹${(item.price*item.qty).toLocaleString('en-IN')}</td>
          <td><button onclick="window.updateQtyPage(${idx},-99)" style="color:#A07855;background:none;border:none;cursor:pointer;font-size:20px;padding:4px 8px;" title="Remove">×</button></td>
        </tr>`).join('');
    }

    const subtotal = getCartTotal();
    const shipping = subtotal >= 500 ? 0 : 60;
    const el = id => document.getElementById(id);
    if(el('cart-subtotal'))   el('cart-subtotal').textContent   = '₹'+subtotal.toLocaleString('en-IN');
    if(el('cart-shipping'))   el('cart-shipping').textContent   = shipping === 0 ? 'FREE' : '₹'+shipping;
    if(el('cart-grand-total'))el('cart-grand-total').textContent= '₹'+(subtotal+shipping).toLocaleString('en-IN');

    /* Notify coupon handler to recalculate discount on top of new subtotal */
    document.dispatchEvent(new Event('valora:cartUpdated'));
  }

  window.updateQtyPage = function(idx, delta){
    if(!cart[idx]) return;
    cart[idx].qty += delta;
    if(cart[idx].qty <= 0) cart.splice(idx,1);
    saveCart(); updateCartUI();
  };

  /* ── FORMS ────────────────────────────────────────────── */
  document.querySelector('.newsletter-form')?.addEventListener('submit', e=>{
    e.preventDefault();
    showToast('You\'re on our sweet list! 🍫');
    e.target.reset();
  });
  document.querySelector('.contact-form form')?.addEventListener('submit', e=>{
    e.preventDefault();
    showToast('Message sent! We\'ll reply within 24 hours.');
    e.target.reset();
  });

  /* ── SCROLL REVEAL ────────────────────────────────────── */
  if('IntersectionObserver' in window){
    const io = new IntersectionObserver(entries=>{
      entries.forEach(entry=>{
        if(entry.isIntersecting){
          entry.target.style.opacity='1';
          entry.target.style.transform='translateY(0)';
          io.unobserve(entry.target);
        }
      });
    },{threshold:0.1,rootMargin:'0px 0px -40px 0px'});

    document.querySelectorAll('.product-card,.why-card,.process-step,.testimonial-card').forEach(el=>{
      el.style.cssText += ';opacity:0;transform:translateY(18px);transition:opacity 0.55s ease,transform 0.55s ease;';
      io.observe(el);
    });
  }

  /* ── HEADER SCROLL EFFECT ─────────────────────────────── */
  let lastScroll = 0;
  const header = document.querySelector('.site-header');
  window.addEventListener('scroll', ()=>{
    const current = window.scrollY;
    if(header){
      if(current > 60){
        header.style.boxShadow = '0 2px 24px rgba(0,0,0,0.4)';
      } else {
        header.style.boxShadow = 'none';
      }
    }
    lastScroll = current;
  }, {passive:true});

  /* ── GLOBAL TAB SWITCHER ──────────────────────────────── */
  window.showTab = function(product, tab){
    ['details','ingredients','nutrition','reviews'].forEach(t=>{
      const el  = document.getElementById(`${product}-${t}`);
      const btn = document.getElementById(`${product}-tab-${t}`);
      if(el) el.style.display = t===tab ? 'block' : 'none';
      if(btn){
        btn.style.color            = t===tab ? 'var(--cocoa)' : 'var(--text-light)';
        btn.style.borderBottomColor= t===tab ? 'var(--gold)'  : 'transparent';
      }
    });
  };

  /* ── INIT ─────────────────────────────────────────────── */
  /*
   * On page load: store variantId on each cart item so the
   * checkout sync can re-add items correctly.
   * The AJAX add-to-cart handler stores variantId at add time.
   * Nothing else needed here — cart sync now happens at click time.
   */
  updateCartUI();

}); /* end DOMContentLoaded */
